import { type Locale } from "@/domain";

import { renderPowerReview, teardownPowerReview } from "./power-review";

export interface ReviewsRatingsPayload {
	sku: string;
	locale: Locale;
	apiKey: string;
	merchantGroupId: string;
	merchantId: string;
}

export interface ReviewsRatingsProvider {
	render(payload: ReviewsRatingsPayload): void;
	teardown(): void;
}

export function getReviewsRatingsProvider(): ReviewsRatingsProvider {
	return {
		render: (payload) =>
			renderPowerReview({
				sku: payload.sku,
				locale: payload.locale,
				apiKey: payload.apiKey,
				merchantGroupId: payload.merchantGroupId,
				merchantId: payload.merchantId
			}),
		teardown: () => teardownPowerReview()
	};
}
